import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerPalletAccountService = {
  async getAllByCode(code) {
    const requestScreenData = {
      url: "api/CustomerPalletAccount",
      filter: `CustomerCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/CustomerPalletAccount",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async save(customerPalletAccount) {
    return await ApiService.post(
      "api/Save_CustomerPalletAccount",
      customerPalletAccount
    );
  },
};

export { CustomerPalletAccountService };
